import { ExpressionValue } from "../../ExpressionValue";
import { BaseStringExpression } from "./BaseString";
import { StringDataDefinition } from "../../../Common/Data/Definitions/StringDataDefinition";
import { ITestingContext } from "../../../Common/Testing/ITestingContext";
import { ExecutionData } from "../../../Common/Data/ExecutionData/ExecutionData";
import type { AppGlueAny } from "../../../Common/AppGlueAny";

export class StringNotContainsExpression extends BaseStringExpression {
    readonly __type: string = "String Not Contains";
    readonly __ruleName: string = "Does Not Contain";
    value1: ExpressionValue;
    value2: ExpressionValue;

    constructor() {
        super();
        this.value1 = ExpressionValue.createExpressionValue(this, "value1", new StringDataDefinition());
        this.value2 = ExpressionValue.createExpressionValue(this, "value2", new StringDataDefinition());
    }

    evaluate(data: ExecutionData, testContext: ITestingContext | undefined): AppGlueAny {
        return !this.value1.evaluate(data, testContext).includes(this.value2.evaluate(data, testContext));
    }
}
